import React, { useState } from "react";

import { Item } from "../../Dropdown/MenuSection/MenuSection";

import ModalRow from "./ModalRow";

import styles from "./ModalSection.module.css";

interface Props<ID extends string, T extends Item<ID>> {
  header: string;
  items: T[];
  onClickItem: (id: ID) => void;
  setFavorite: (id: ID) => Promise<void>;
  isLoading: boolean;
  headerEnd?: React.ReactNode;
}

const ModalSectionWithItems = <ID extends string, T extends Item<ID>>({
  header,
  items,
  onClickItem,
  setFavorite,
  isLoading,
  headerEnd,
}: Props<ID, T>) => {
  const [loadingId, setLoadingId] = useState<ID | null>(null);

  const handleClickItem = (id: ID) => () => {
    onClickItem(id);
  };

  const handleSetFavorite = (id: ID) => async () => {
    setLoadingId(id);
    await setFavorite(id);
    setLoadingId(null);
  };

  return (
    <>
      <div className={styles.flexBetween}>
        <div className={styles.heading}>{header}</div>
        {headerEnd}
      </div>

      <div className={styles.scrollBox}>
        {items.map((el) => (
          <ModalRow
            key={el.id}
            name={el.name}
            onClick={handleClickItem(el.id)}
            isFavorite={el.isFavorite}
            setFavorite={handleSetFavorite(el.id)}
            isLoading={loadingId === el.id}
          />
        ))}

        {isLoading === false && items.length === 0 && (
          <div className={styles.noOptionsText}>None</div>
        )}
      </div>
    </>
  );
};

export default ModalSectionWithItems;
